import React, { Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Outlet } from "react-router-dom";
import "./App.scss";
import NavBar from "./components/NavBar.js";
import LoadingSpinner from "./components/LoadingSpinner";
import { RecoilRoot } from "recoil";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 1000 * 60, // 5 minutes
      refetchOnMount: "always",
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
    },
  },
});

function App() {
  return (
    <RecoilRoot>
      <QueryClientProvider client={queryClient}>
        <NavBar />
        <Suspense fallback={<LoadingSpinner />}>
          <Outlet />
        </Suspense>
      </QueryClientProvider>
    </RecoilRoot>
  );
}

export default App;
